import React, { useState } from 'react';

interface HelpIconProps {
  tooltipText: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ tooltipText }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="absolute top-0 left-0">
      <div
        className="flex items-center justify-center w-5 h-5 rounded-full bg-gray-200 text-gray-600 text-xs font-medium cursor-help hover:bg-gray-300 transition-colors"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={() => setIsVisible(!isVisible)}
      >
        ?
      </div>
      
      {isVisible && (
        <div className="absolute z-10 p-2 mt-1 text-sm text-white bg-gray-800 rounded shadow-lg whitespace-nowrap left-1/2 transform -translate-x-1/2">
          {tooltipText}
          <div className="absolute w-2 h-2 bg-gray-800 transform rotate-45 -top-1 left-1/2 -translate-x-1/2"></div>
        </div>
      )}
    </div>
  );
};

export default HelpIcon; 